import styled from '@emotion/styled'

export const StyleInput = styled.input<any>`
  width: 100%;
  border-radius: 6px;
  height: 45px;
  text-indent: 10px;
  padding: 0px;
  border: 1px solid
    ${(props) =>
      props?.isFocus
        ? props.theme.colors.primary
        : props?.hasError
          ? props.theme.colors.danger
          : props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Poppins;
  }

  ${(props) => props.styleInput}
`

export const StyleIconWrapper = styled.div<any>`
  position: absolute;
  top: 34px;
  right: 0px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`
